import THEME, { COLOR } from '@maxpreps/shared/styles/colors';
import { appendClassName } from '@maxpreps/shared/styles/css';
import React from 'react';
import styled, { useTheme } from 'styled-components';
import { isValidColor } from '../../functions/primitiveHelpers/colorHelpers';
import Image, { getSizeStyles, IPhotoProps } from './Image';

const StyledFallback = styled.div<{
  $backgroundColor?: string;
  $size: number;
  $maxSize?: number;
  $border?: string;
  $textColor?: string;
}>`
  font-weight: 700;
  border-radius: 50%;
  background: ${props => props.$backgroundColor};
  ${props => (props.$border ? `border:${props.$border}` : '')};
  text-align: center;
  color: ${props => props.$textColor};

  ${({ $size, $maxSize }) => getSizeStyles($size, $maxSize)};

  line-height: ${props => props.$size - 2}px;
  font-size: ${props => props.$size - 6}px;
`;

export interface IPhotoOrInitialProps
  extends Omit<IPhotoProps, 'height' | 'width'> {
  size: number;
  maxSize?: number;
  fallbackLetter: string;
  backgroundColor?: string;
  textColor?: string;
  border?: string;
}

const PhotoOrInitial: React.FC<IPhotoOrInitialProps> = ({
  fallbackLetter,
  backgroundColor,
  textColor,
  className,
  size = 40,
  maxSize,
  src,
  border,
  borderRadius = '50%',
  ...rest
}) => {
  const theme = useTheme();

  const fallback = (
    <StyledFallback
      $size={size}
      $maxSize={maxSize}
      $backgroundColor={
        isValidColor(backgroundColor)
          ? backgroundColor
          : theme?.colors.school.primary ?? THEME.brand.maxpreps
      }
      $textColor={textColor ?? COLOR.white}
      $border={border}
      className={appendClassName('photo-or-initial', className)}
    >
      {fallbackLetter?.charAt(0) ?? '?'}
    </StyledFallback>
  );

  return (
    <Image
      className={appendClassName('photo-or-initial', className)}
      size={size}
      maxSize={maxSize}
      fallback={fallback}
      src={src}
      borderRadius={borderRadius}
      {...rest}
    />
  );
};

export default PhotoOrInitial;
